export const environment = {
  production: true,
  hmr: false,
  apiUrl: 'https://api.euroed.pt/api'
  //apiUrl: 'http://mst.midupe.pt:8000/api'
  //apiUrl: 'http://192.168.0.180:8000/api'
};
